'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildNavLinks = exports.buildLegal = exports.getAbsoluteUrl = exports.check_cta_url = exports.getConfig = exports.getBaseUrl = exports.images = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _nav = require('./configurations/nav.json');

var _nav2 = _interopRequireDefault(_nav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utility function for loading all images in a directory
// See https://stackoverflow.com/questions/42118296/dynamically-import-images-from-a-directory-using-webpack
var importAll = function importAll(r) {
  var images = {};
  r.keys().forEach(function (item, index) {
    images[item.replace('./', '')] = r(item);
  });
  return images;
};

var getImages = function getImages() {
  try {
    return importAll(require.context('./images', false, /\.(png|jpe?g|svg)$/));
  } catch (e) {
    try {
      var path = require('path');
      var fs = require('fs');
      var _images = {};

      if (fs.statSync(path.join(__dirname, 'images')).isDirectory()) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = fs.readdirSync(path.join(__dirname, 'images'))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;

            _images[child.replace('./', '')] = '/images/' + child;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return _images;
    } catch (err) {
      print(err);
      return {};
    }
  }
};

var images = exports.images = getImages();

var getBaseUrl = exports.getBaseUrl = function getBaseUrl() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var baseUrlProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  // Determine the base url based off props and brand
  if (baseUrlProp) {
    return baseUrlProp;
  }

  var baseUrl = '';
  if (brand && brand in _nav2.default.brands) {
    baseUrl = _nav2.default.brands[brand].baseUrl;
  } else {
    baseUrl = _nav2.default.brands.default.baseUrl;
  }
  return baseUrl;
};

var getConfig = exports.getConfig = function getConfig() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var config = _nav2.default.brands.default;

  // Use the right config based on brand
  if (brand && _nav2.default.brands[brand]) {
    config = _nav2.default.brands[brand];
  }

  // Override with page-specific configuration
  var path = typeof window !== "undefined" ? window.location.pathname.slice(1, window.location.pathname.length - 1) : null;

  if (path && "pages" in config && path in config.pages) {
    config.top = _extends({}, config.top, config.pages[path].top);

    config.sidebar = _extends({}, config.sidebar, config.pages[path].sidebar);
  }
  config = replaceConfigUrls(config, brand, baseUrl);
  config = addLinkActions(config, actions);

  return config;
};

var check_cta_url = exports.check_cta_url = function check_cta_url(cta) {
  if (!cta || !('href' in cta) || cta.href.length === 0) {
    return null;
  }

  return { text: cta.text, href: getAbsoluteUrl(cta.href) };
};

var getAbsoluteUrl = exports.getAbsoluteUrl = function getAbsoluteUrl(url, baseUrl) {
  var fullUrl = baseUrl;

  if (url) {
    // If already an absolute url just return
    if (url.indexOf("http") > -1) return url;
    fullUrl += '' + url;
  }

  return fullUrl;
};

var buildLegal = exports.buildLegal = function buildLegal(legalItems, baseUrl) {
  for (var i = 0; i < legalItems.length; i++) {
    for (var j = 0; j < legalItems[i].length; j++) {
      if (legalItems[i][j].type === "link") {
        legalItems[i][j] = replaceLinkReference(legalItems[i][j]);
        legalItems[i][j].href = getAbsoluteUrl(legalItems[i][j].href, baseUrl);
      }
    }
  }

  return legalItems;
};

var buildNavLinks = exports.buildNavLinks = function buildNavLinks(links, baseUrl, actions) {
  var navLinks = links.map(function (link) {
    link = replaceLinkReference(link);
    if (link.action && link.action in actions) link.onClick = actions[link.action];
    link.href = getAbsoluteUrl(link.href, baseUrl);
    return link;
  });

  return navLinks;
};

///////////////////////
// PRIVATE UTILITIES //
///////////////////////

var replaceConfigUrls = function replaceConfigUrls(baseConfig, brand, baseUrl) {

  var config = JSON.parse(JSON.stringify(baseConfig));

  // This function will take the provided baseUrl prop and build
  // absolute urls for all the (relative) links in the config

  // First replace the general URLs
  config.baseUrl = baseUrl ? baseUrl : config.baseUrl;

  for (var i = 0; i < config.top.links.length; i++) {

    config.top.links[i] = replaceLinkReference(config.top.links[i]);

    if (config.top.links[i].type === "link" || config.top.links[i].type === "button") {
      config.top.links[i].href = getAbsoluteUrl(config.top.links[i].href, config.baseUrl);
    }
  }

  for (var _i = 0; _i < config.sidebar.mainLinks.length; _i++) {
    config.sidebar.mainLinks[_i] = replaceLinkReference(config.sidebar.mainLinks[_i]);
    config.sidebar.mainLinks[_i].href = getAbsoluteUrl(config.sidebar.mainLinks[_i].href, config.baseUrl);
  }

  for (var _i2 = 0; _i2 < config.sidebar.legal.length; _i2++) {
    for (var j = 0; j < config.sidebar.legal[_i2].length; j++) {

      config.sidebar.legal[_i2][j] = replaceLinkReference(config.sidebar.legal[_i2][j]);

      if (config.sidebar.legal[_i2][j].type === "link") {
        config.sidebar.legal[_i2][j].href = getAbsoluteUrl(config.sidebar.legal[_i2][j].href, config.baseUrl);
      }

      if (config.sidebar.legal[_i2][j].type === "image") {
        config.sidebar.legal[_i2][j].src = images[config.sidebar.legal[_i2][j].src];
      }
    }
  }

  // Logo url
  if (config.top.logoUrl) {
    config.top.logoUrl = getAbsoluteUrl(config.top.logoUrl, config.baseUrl);
  }

  // CTA url
  if (check_cta_url(config.top.cta)) {
    config.top.cta.href = getAbsoluteUrl(config.top.cta.href, config.baseUrl);
  }
  if (check_cta_url(config.sidebar.cta)) {
    config.sidebar.cta.href = getAbsoluteUrl(config.sidebar.cta.href, config.baseUrl);
  }

  return config;
};

var addLinkActions = function addLinkActions(baseConfig) {
  var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var config = JSON.parse(JSON.stringify(baseConfig));
  for (var i = 0; i < config.top.links.length; i++) {
    if (config.top.links[i].action && config.top.links[i].action in actions) {
      config.top.links[i].onClick = actions[config.top.links[i].action];
    }
  }
  for (var _i3 = 0; _i3 < config.sidebar.mainLinks.length; _i3++) {
    if (config.sidebar.mainLinks[_i3].action && config.sidebar.mainLinks[_i3].action in actions) {
      config.sidebar.mainLinks[_i3].onClick = actions[config.sidebar.mainLinks[_i3].action];
    }
  }
  return config;
};

var replaceLinkReference = function replaceLinkReference(link) {

  // There are some common links defined in the JSON
  // that get referenced by brand-specific configs
  // so this function checks for the "use" key and
  // replaces with the common link if necessary
  if ("use" in link) {
    link = _extends({}, _nav2.default.links[link.use], link);
  }

  return link;
};


//////////////////
// WEBPACK FOOTER
// ./~/buoy-config/dist/utils.js
// module id = 399
// module chunks = 168707334958949